// Module
var code = "<ul> <li><a href=\"/manage/resources/glossary\">Glossary</a></li> <li><a href=\"/manage/resources/forms\">Forms</a></li> <li><a href=\"/faqs\" target=\"_blank\">FAQ</a></li> </ul> ";
// Exports
export default code;